/* tslint:disable */
/* eslint-disable */
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import { SuccessResponse_1OfGetStockResponse, SuccessResponse_1OfStockItem, PutStockRequest } from '../types';
import { isAxiosError, throwException } from '../base';

import { IStockClient } from '../interfaces';
export class StockClient implements IStockClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param storeNumber (optional) 
     * @param search (optional) 
     * @param fieldToSort (optional) 
     * @param sortDirection (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @param filters (optional) 
     * @param categoryFilters (optional) 
     * @param storeFilters (optional) 
     * @param hasRecentActivity (optional) 
     * @param isMadeInStore (optional) 
     * @return Success
     */
    stockGET(storeNumber?: string | undefined, search?: string | undefined, fieldToSort?: string | undefined, sortDirection?: string | undefined, skip?: number | undefined, take?: number | undefined, filters?: string | undefined, categoryFilters?: string | undefined, storeFilters?: string | undefined, hasRecentActivity?: boolean | undefined, isMadeInStore?: boolean | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfGetStockResponse> {
        let url_ = this.baseUrl + "/stock?";
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "StoreNumber=" + encodeURIComponent("" + storeNumber) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (fieldToSort === null)
            throw new Error("The parameter 'fieldToSort' cannot be null.");
        else if (fieldToSort !== undefined)
            url_ += "FieldToSort=" + encodeURIComponent("" + fieldToSort) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (categoryFilters === null)
            throw new Error("The parameter 'categoryFilters' cannot be null.");
        else if (categoryFilters !== undefined)
            url_ += "CategoryFilters=" + encodeURIComponent("" + categoryFilters) + "&";
        if (storeFilters === null)
            throw new Error("The parameter 'storeFilters' cannot be null.");
        else if (storeFilters !== undefined)
            url_ += "StoreFilters=" + encodeURIComponent("" + storeFilters) + "&";
        if (hasRecentActivity === null)
            throw new Error("The parameter 'hasRecentActivity' cannot be null.");
        else if (hasRecentActivity !== undefined)
            url_ += "HasRecentActivity=" + encodeURIComponent("" + hasRecentActivity) + "&";
        if (isMadeInStore === null)
            throw new Error("The parameter 'isMadeInStore' cannot be null.");
        else if (isMadeInStore !== undefined)
            url_ += "IsMadeInStore=" + encodeURIComponent("" + isMadeInStore) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStockGET(_response);
        });
    }

    protected processStockGET(response: AxiosResponse): Promise<SuccessResponse_1OfGetStockResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfGetStockResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfGetStockResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    stockPUT(body?: PutStockRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/stock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStockPUT(_response);
        });
    }

    protected processStockPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param storeNumber (optional) 
     * @return Success
     */
    stockGET2(itemNumber: string, storeNumber?: string | undefined, cancelToken?: CancelToken | undefined): Promise<SuccessResponse_1OfStockItem> {
        let url_ = this.baseUrl + "/stock/{itemNumber}?";
        if (itemNumber === undefined || itemNumber === null)
            throw new Error("The parameter 'itemNumber' must be defined.");
        url_ = url_.replace("{itemNumber}", encodeURIComponent("" + itemNumber));
        if (storeNumber === null)
            throw new Error("The parameter 'storeNumber' cannot be null.");
        else if (storeNumber !== undefined)
            url_ += "storeNumber=" + encodeURIComponent("" + storeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStockGET2(_response);
        });
    }

    protected processStockGET2(response: AxiosResponse): Promise<SuccessResponse_1OfStockItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SuccessResponse_1OfStockItem>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuccessResponse_1OfStockItem>(<any>null);
    }
}
